import React from 'react'
import {
  Button,
  Col,
  Container,
  Row,
  Table
} from 'reactstrap'
import { ListItem } from '.'
import { IgtLoader } from 'Atoms'
import { CSVLink } from "react-csv";


const CSVDataToDownloadFormat = (data) => {
  return data.map(department => {
    return {
      department_name: department.name,
      abbreviation: department.abbreviation
    }
  })
}

const DepartmentsList = ({ modelList, isLoading }) => {

  return (
    <Container fluid>
      {console.log(modelList)}
      <Row>
        <Col lg={{ size: 6, offset: 3 }}>
          <h1 className="text-center">Departments Table</h1>
        </Col>
        <Col lg="3">
          <Button href="/auth/create/departments">Add New Department</Button>{' '}
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
              <IgtLoader isLoading={isLoading} />
              :
              <>
              <Button style={{ margin: '5px' }} >
            {modelList && (
              <CSVLink 
              style={{color: "white"}}
                data={CSVDataToDownloadFormat(modelList)} 
                filename={'department_' + new Date().toISOString() + '.csv'}
              >
                Download CSV
              </CSVLink>
            )}
          </Button>
              <Table hover>
                <thead className='sticky-header'>
                  <tr>
                    <th>Name</th>
                    <th>Abbreviation</th>
                  </tr>
                </thead>
                <tbody>
                  
                  {
                    modelList && modelList.map((department, i) => {
                      return (
                        <ListItem
                          modelListItem={department}
                          key={i}
                          index={i}
                        />
                      )
                    })
                  }
                </tbody>
              </Table>
              </>

          }
          
        </Col>
      </Row>
    </Container>
  )
}

export default DepartmentsList